<div class="department-list">
  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  
  <div *ngIf="!loading && departments.length === 0" class="empty-state">
    {{ 'request_v2.department_list.no_departments' | translate }}
  </div>
  
  <app-department-card
    *ngFor="let department of departments"
    [department]="department"
    (edit)="onEdit(department)"
    (delete)="onDelete(department)">
  </app-department-card>
</div> 